<ng-template #thumbnailContent>
  <div class="thumbnail-item__indicators">
    <div
      class="thumbnail-item__checkbox-container"
      [ngClass]="{
        'thumbnail-item__checkbox-container--selected' : isSelected,
        'thumbnail-item__checkbox-container--disabled' : isDisabled
       }"
    >
      <span
        [matTooltip]="tooltipText"
        (click)="$event.stopPropagation()"
        (keydown)="null"
      >
        <mat-checkbox
          (click)="onItemSelect($event)"
          (change)="onSelectedChange($event)"
          (keydown)="null"
          [checked]="isSelected"
          [disabled]="isDisabled"
        />
      </span>
    </div>

    @if (item?.is_restricted) {
      <app-restricted-indicator/>
    }
  </div>

  <app-search-result-thumbnail-image
    class="thumbnail-item__thumb"
    [item]="item"
  />

  <div class="thumbnail-item__content">
    <div class="thumbnail-item__text">
      <div class="thumbnail-item__title">
        <mat-icon class="thumbnail-item__icon">
          {{ getMaterialSymbol(item.object_type) }}
        </mat-icon>

        <span
          [innerHTML]="item.artifact_name_short || item.artifact_name"
        ></span>
      </div>

      @for (label of item.overview_simple; track $index) {
        <span
          class="thumbnail-item__description"
          [innerHTML]="label.value"
        ></span>
      }
    </div>
  </div>

  @if (hasIndicator) {
    <div class="thumbnail-item__indicator">
      <ng-content select="[indicator]"/>
    </div>
  }
</ng-template>

@if (routerLink) {
  <a
    id="{{item.artifact_id}}"
    class="thumbnail-item thumbnail-item--clickable"
    [ngClass]="{'thumbnail-item--selected' : isSelected, 'thumbnail-item--disabled' : isDisabled}"
    queryParamsHandling="merge"
    [queryParams]="queryParams"
    [routerLink]="routerLink"
  >
    <ng-container *ngTemplateOutlet="thumbnailContent"></ng-container>
  </a>
} @else {
  <div
    id="{{item.artifact_id}}"
    class="thumbnail-item"
    [ngClass]="{'thumbnail-item--selected' : isSelected, 'thumbnail-item--clickable' : click.observed}"
    (click)="onItemClick($event)"
  >
    <ng-container *ngTemplateOutlet="thumbnailContent"></ng-container>
  </div>
}
